import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/vehicles", label: "Supported Vehicles" },
  { to: "/tuning", label: "Tuning" },
  { to: "/fabrication", label: "Fabrication" },
  { to: "/build", label: "Build" },
  { to: "/performance", label: "Performance" },
];

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-200 border-b ${
        scrolled ? "bg-void/95 backdrop-blur-md border-[#222]" : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img src="/vp-logo-neon.png" alt="Vice Performance" className="h-9 md:h-11 w-auto group-hover:scale-110 transition-transform" />
          <span className="font-display text-xl md:text-2xl uppercase tracking-tight leading-none">
            Vice<span className="text-neon">Performance</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.slice(1)}`}
              className={`text-xs uppercase tracking-[0.2em] transition-colors hover:text-neon ${
                pathname === l.to ? "text-neon" : "text-[#9CA3AF]"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/build"
            data-testid="nav-cta"
            className="bg-neon text-void text-xs uppercase tracking-[0.2em] font-bold py-3 px-6 hover:bg-[#FAFAFA] transition-colors"
          >
            Request Build
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[#FAFAFA]"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-void border-t border-[#222] px-5 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-mobile-${l.to.slice(1)}`} className="text-sm uppercase tracking-[0.2em] text-[#FAFAFA]">
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
